export default "<router-outlet></router-outlet>\r\n<app-spinner></app-spinner>";